import React from 'react';
import { useQuery } from '@apollo/client';
import { Field } from 'formik';
import ReactSelect from 'components/Fields/ReactSelect';
import Loader from 'components/common/Loader';
import { SUBCATEGORY_LIST } from 'pages/Products/ProductsGraphQL';

const GradeTypeSelectField = ({ required = false, isDisabled = false }) => {
  const { data, loading, error } = useQuery(SUBCATEGORY_LIST, {
    variables: {
      filter: [],
      // pageNo: 0,
      // pageSize: 30,
      // sortCol: null,
      // sortDirection: null,
      pagination: false,
    },
    fetchPolicy: 'network-only',
  });

  if (loading) return <Loader />;
  if (error) return `There is an error on this page : ${error.message} `;

  const options = [
    {
      id: 'DOMESTIC',
      name: 'DOMESTIC',
    },
    {
      id: 'IMPORT',
      name: 'IMPORT',
    },
  ];

  return (
    <div>
      <Field
        name="gradeType"
        label="Type"
        type="select"
        component={ReactSelect}
        data={options}
        keys={{ id: 'id' }}
        getOptionValue={(option) => option.id}
        getOptionLabel={(option) => option.name}
        required={required}
        isDisabled={isDisabled}
      />
    </div>
  );
};

export default GradeTypeSelectField;
